import React from "react";
import "../../styles/contact.css";
import InnerBanner from "../../common/InnerBanner";

const ContactPg = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      <InnerBanner name="Contact Us" />
      <div className="contact_us_main container">
        <div className="contact_us_left">
          <h3>Get a quote</h3>
          <form onSubmit={handleSubmit}>
            <input type="text" placeholder="Your name*" required />
            <div>
              <input type="text" placeholder="Email address*" required />
              <input type="text" placeholder="Your name*" />
            </div>
            <textarea
              id="message"
              name="message"
              rows="4"
              cols="50"
              placeholder="Message"
            ></textarea>
            <button type="submit">Send</button>
          </form>
        </div>
        <div className="contact_us_right dm-sans">
          <h3>Get Info</h3>
          <div className="contact_address">
            <div className="d-flex align-content-center gap-2 mb-2">
              <i className="bi bi-house"></i>
              <span>SkudMart Headquarter</span>
            </div>
            <span className="address">
              PO Box 16122 Collins Street West Victoria 8007 Australia
            </span>
          </div>
          <div className="contact_address">
            <div className="d-flex align-content-center gap-2 mb-2">
              <i className="bi bi-house"></i>
              <span>SkudMart Headquarter</span>
            </div>
            <span className="address">West Victoria 8007 Australia</span>
          </div>
          <div className="contact_address">
            <div className="d-flex align-content-center gap-2 mb-2">
              <i class="bi bi-envelope"></i>
              <span>info@la-studioweb.com</span>
            </div>
          </div>
          <div className="contact_address">
            <div className="d-flex align-content-center gap-2 mb-2">
              <i class="bi bi-phone"></i>
              <span>+812-466-7130</span>
            </div>
          </div>
        </div>
      </div>
      <div className="contact_us_map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7226.292599742616!2d55.15488081543085!3d25.09690851073162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6b43c675c243%3A0x7dfdb7a273cf2c58!2sAl%20Sufouh%20-%20Dubai%20Media%20City%20-%20Dubai!5e0!3m2!1sen!2sae!4v1723536045292!5m2!1sen!2sae"
          width="100%"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactPg;
